<template>
    <footer class="text-muted py-5">
      <div class="container">
        <p class="float-end mb-1">
          <a href="#">Revenir en haut de la page</a>
        </p>
        <p class="mb-1">Problèmes en ligne, des problèmes pour et dans la classe.</p>
        <p class="mb-0">À découvrir, les <a href="https://arnaud-lierville.github.io/" target="_blank">Outils Maths en classe !</a></p>
      </div>
    </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* bootstrap-vue fixing */
  .float-end {
      float: right!important;
  }
</style>    